(function ($) {
  mascaraModuleRowV1 = {
    formatter: $('.mascara-module-row-v1')
  };

  Drupal.behaviors.mascaraModuleRowV1 = {
    get: function (key) {
      return mascaraModuleRowV1[key];
    },

    set: function (key, val) {
      mascaraModuleRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // Hide all carets
        thisFormatter.find('.caret').hide();

        // quickview slide down
        thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          var self = $(this);

          $('#quickshop .close').trigger('click');
          var prodId = $(this).closest('.product').attr('data-prodid');

          // Show/hide caret
          $(this).closest('.product').find('.caret').toggle();
          $(this).closest('.product').siblings().find('.caret').hide();
          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p.PRODUCT_ID === prodId;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });
            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
            // Scroll and return to previous top position
            // $('body, html').scrollTo($('#top').height() - (extraDistance * 2), {duration: 1000, axis: "y"});
              $qs.slideUp('500', function () {
                $qs.remove();
              });
              // hide caret
              self.closest('.product').find('.caret').hide();
            });
          }
        });
      });

      $('.button.cta', context).on('click', function(e) {
        e.preventDefault();
        // iterate through each product div to get sku for 'add all to cart'
        var buySkus = [];

        $($(e.target).parents('.row').get(0)).find('.product[data-prodid]').each(function () {
          buySkus.push($(this).attr('data-skubaseid'));
        });
        var loadingId = site.loading.show({
          'target': e.target,
          'matchTarget': ['display', 'height', 'width'],
          'css': {
            'text-align': 'center',
            'vertical-align': 'bottom',
            'margin-bottom': '-79px'
          }
        });

        // add sku array to cart
        site.addToCart({
          skuBaseId: buySkus
        });
        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
    }
  };
})(jQuery);
